<template>
  <button
    class="action-icon"
    :aria-label="explanation"
    data-balloon-pos="up"
    :style="customStyle"
    @click.stop="handleAction"
  >
    <span class="sr-only">{{ explanation }}</span>
    <i :class="icon"></i>
    <i
      v-if="hoverIcon"
      :class="hoverIcon"
      class="hover-icon"
    ></i>
  </button>
</template>

<script>
  export default {
    name: 'ActionIcon',

    props: {
      explanation: {
        type: String,
        default: 'Action'
      },
      icon: {
        type: String,
        default: 'fa-light fa-circle'
      },
      hoverIcon: {
        type: String,
        default: null
      },
      customStyle: {
        type: Object,
        default: () => ({})
      }
    },

    emits: ['action'],

    methods: {
      handleAction() {
        this.$emit('action')
      }
    }
  }
</script>
